<template>
  <div class="christmas-lights">
    <svg class="light-wire" viewBox="0 0 100 20" preserveAspectRatio="none">
      <path d="M0 10 Q 25 0, 50 10 T 100 10" />
    </svg>
    <div
      v-for="light in lights"
      :key="light.id"
      class="light-bulb"
      :style="light.style"
    >
      <div class="bulb-inner"></div>
      <div class="bulb-wire"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChristmasLightsComponent',
  data() {
    return {
      lights: []
    }
  },
  mounted() {
    const colors = ['#ff3b3b', '#2ecc71'] // rouge & vert

    this.lights = Array.from({ length: 20 }, (_, i) => {
      const color = colors[i % 2]
      const x = (i / 20) * 100 // position en %
      const delay = (Math.random() * 2).toFixed(2) + 's'

      return {
        id: i,
        style: {
          left: `${x}%`,
          '--bulb-color': color,
          animation: `blink ${Math.random() * 2 + 1}s ${delay} infinite`
        }
      }
    })
  }
}
</script>

<style>
/* Container */
.christmas-lights {
  position: absolute;
  top: 0;
  width: 100%;
  height: 120px;
  pointer-events: none;
}

/* Fil ondulé (SVG) */
.light-wire {
  width: 100%;
  height: 40px;
  stroke: #3b3b3b;
  stroke-width: 0.6;
  fill: none;
}

/* Ampoules */
.light-bulb {
  position: absolute;
  top: 22px;
  transform: translateX(-50%);
}

/* Petit fil qui suspend l'ampoule */
.bulb-wire {
  width: 2px;
  height: 15px;
  background: #3b3b3b;
  margin: 0 auto;
}

/* Corps de l'ampoule */
.bulb-inner {
  width: 18px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--bulb-color);
  box-shadow: 0 0 6px var(--bulb-color);
  animation: glow 2s infinite ease-in-out;
}

/* Clignotement ON/OFF */
@keyframes blink {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(0.85);
  }
}

/* Glow doux */
@keyframes glow {
  0%,
  100% {
    box-shadow: 0 0 8px 2px var(--bulb-color);
  }
  50% {
    box-shadow: 0 0 2px 1px var(--bulb-color);
  }
}
</style>
